// src/config/app.config.ts
// Single source of truth for all environment-driven configuration

export const appConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5111',
  appName: import.meta.env.VITE_APP_NAME || 'RMV Hospital',

  session: {
    /** Inactivity timeout in seconds before auto-logout */
    timeoutSeconds: Number(import.meta.env.VITE_SESSION_TIMEOUT) || 900,
    /** Seconds before timeout to show the warning modal */
    warningSeconds: Number(import.meta.env.VITE_SESSION_WARNING) || 60,
  },

  deployment: {
    basePath: import.meta.env.VITE_BASE_PATH || '/',
    embedMode: import.meta.env.VITE_EMBED_MODE === 'true',
  },
} as const;

export type AppConfig = typeof appConfig;
